import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreInvitationsModule } from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { CreateInvitationInputComponent } from './create-invitation-input/create-invitation-input.component';
import { CreateInvitationListComponent } from './create-invitation-list/create-invitation-list.component';
import { CreateInvitationModalComponent } from './create-invitation-modal.component';
import { CreateInvitationShareLinkComponent } from './create-invitation-share-link/create-invitation-share-link.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreInvitationsModule,
    UiModule,
    PipesModule,
    TrackingModule,
  ],
  declarations: [
    CreateInvitationModalComponent,
    CreateInvitationListComponent,
    CreateInvitationInputComponent,
    CreateInvitationShareLinkComponent,
  ],
  exports: [CreateInvitationInputComponent],
  entryComponents: [CreateInvitationModalComponent],
})
export class CreateInvitationModalModule {}
